import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint, BookOpen, Scissors, Ruler, Sparkles, TrendingUp } from 'lucide-react';
const benefits = [{
  icon: BookOpen,
  title: '+100 moldes profesionales'
}, {
  icon: Sparkles,
  title: 'Paso a paso fácil'
}, {
  icon: PawPrint,
  title: 'Para perros y gatos'
}, {
  icon: Ruler,
  title: 'Diferentes talles (XS a XL)'
}, {
  icon: Scissors,
  title: 'Modelos modernos'
}, {
  icon: TrendingUp,
  title: 'Ideal para emprender'
}];
export function Benefits() {
  return <section id="beneficios" className="py-20 bg-white" data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-16">
            Todo lo que vas a{' '}
            <span className="font-script text-brand-rose text-4xl md:text-5xl lowercase" data-id="element-17">
              recibir
            </span>
          </h2>
          <div className="w-24 h-1 bg-brand-pink-mid mx-auto rounded-full" data-id="element-18"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-8" data-id="element-19">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-cream-light p-6 sm:p-8 rounded-3xl text-center group hover:-translate-y-1 transition-all duration-300 hover:shadow-soft-pink border border-transparent hover:border-brand-pink-light" data-id="element-20">
              <div className="w-16 h-16 mx-auto bg-brand-pink-light rounded-2xl flex items-center justify-center text-brand-rose mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-21">
                <benefit.icon size={32} strokeWidth={1.5} data-id="element-22" />
              </div>
              <h3 className="font-sans font-bold text-lg text-brand-brown" data-id="element-23">
                {benefit.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}